<template>
  <b-modal
    id="migrarContrato"
    title="MIGRAR CONTRATO"
    size="lg"
    hide-footer
    @shown="onModalShown"
  >
    <div class="card">
      <div class="card-body">
        <div class="container-fluid h-100">
          <form
            @submit.prevent="submit"
            v-promise-btn="{ action: 'submit' }"
            ref="form"
          >
            <div class="row">
              <div class="col-12 col-md-6 form-group form-group-md">
                <label for="nombre_cliente_nuevo" class="label"
                  >Nombre de cliente actual</label
                >
                <input
                  id="nombre_cliente_nuevo"
                  v-model="nombreCliente"
                  :class="`form-control form-control-sm text-center bg-white`"
                  disabled
                  type="text"
                />
              </div>
              <div class="col-12 col-md-6 form-group form-group-md">
                <label for="avl" class="label">id contrato</label>
                <input
                  type="text"
                  :class="`form-control form-control-sm text-center bg-white`"
                  disabled
                  id="avl"
                  v-model="idContrato"
                />
              </div>
              <div class="col-12 form-group">
                <div class="card">
                  <div class="card-body">
                    <div class="col-12 form-group form-group-md">
                      <div
                        class="form-group form-group-sm d-flex align-items-center mb-2"
                      >
                        <input
                          id="sinContratos"
                          v-model="sinContratos"
                          class="form-check-inline"
                          type="checkbox"
                          style="zoom: 1.2"
                        />
                        <label class="label mb-0" for="sinContratos"
                          >Mostrar clientes sin contratos</label
                        >
                      </div>
                      <label for="nombre_cliente_nuevo" class="label"
                        >Nombre de cliente Nuevo</label
                      >
                      <SelectorClienteVigente
                        v-model="idClienteNuevo"
                        :incluirSoloSinContrato="sinContratos"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div class="w-100 d-flex justify-content-end">
                  <button
                    type="button"
                    class="btn btn-danger"
                    @click="$bvModal.hide('migrarContrato')"
                  >
                    Cancelar
                  </button>
                  <button type="submit" class="btn btn-primary">Guardar</button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </b-modal>
</template>
<script>
import NombreCliente from "../../../shared/NombreCliente";
import SelectorClienteVigente from "../../../shared/SelectorClienteVigente.vue";
import { get } from "lodash-es";
import axios from "axios";

export default {
  name: "migrar-contrato-form",
  components: { SelectorClienteVigente },
  mounted() {
    // this.idCliente = this.$route.params.id_cliente;
    this.getNombreCliente(this.$route.params.id_cliente);
    this.idContrato = this.$route.params.id_contrato;
  },
  mixins: [NombreCliente],
  data: () => ({ idClienteNuevo: null, idContrato: null, sinContratos: false }),
  methods: {
    onModalShown() {
      this.idClienteNuevo = null;
    },
    resetClienteConLoading() {
      this.idClienteNuevo = null;
    },
    async submit() {
      if (!this.idClienteNuevo) {
        this.$msgBoxOk("Debe seleccionar un cliente nuevo");
        return;
      } else {
        console.log(this.idClienteNuevo);
      }
      let migrarContrato = false;
      const confirmacion = await this.$bvModal.msgBoxConfirm(
        `¿Está seguro que desea migrar el contrato del cliente ${this.nombreCliente} al cliente ${this.idClienteNuevo.nombre_web}? Se pasarán los cobros restantes del mes al nuevo cliente.`,
        {
          title: "Advertencia",
          centered: true,
          okTitle: "SI",
          cancelTitle: "NO",
        },
      );
      if (confirmacion) {
        migrarContrato = true;
      }

      if (migrarContrato) {
        const resp = await axios.post("/execute", {
          method: "CLI.MigrarContrato",
          parameters: [
            { name: "id_cliente_nuevo", value: this.idClienteNuevo.id_cliente },
            { name: "id_contrato", value: this.idContrato },
          ],
        });
        if (get(resp, "data,ok", true)) {
          this.$msgBoxOk(
            "Se realizo el cambio con exito, será redirigido al contrato actual",
          );
          this.$router.push(
            `/admin/clientes/${this.idClienteNuevo.id_cliente}/contratos/${this.$route.params.id_contrato}`,
          );
          this.$emit("update");
          this.$bvModal.hide("migrarContrato");
        } else {
          this.$msgBoxOk(
            get(
              resp,
              "data.message",
              "Ha ocurrido un error, no se puedo migrar el contrato",
            ),
          );
        }
      }
    },
  },
  watch: {
    sinContratos() {
      this.resetClienteConLoading();
    },
  },
};
</script>
